import './App.css'
import React, { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'

import CssBaseline from '@material-ui/core/CssBaseline'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Box from '@material-ui/core/Box'

// We don't need these contexts that require authentication
// import { ResolutionProvider } from '@graniot/common/context/ResolutionContext'
// import { LayersProvider } from '@graniot/common/context/LayersContext'
// import { PublicLayersProvider } from './context/PublicLayersContext'
import { LocationProvider } from '@graniot/common/context/LocationContext'

// Import the simplified public map app
import PublicMapApp from './PublicMapApp'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 2,
        },
    },
})

const theme = createTheme({
    palette: {
        primary: {
			main: '#232C57',
            light: '#b47cff',
            dark: '#3f1dcb',
            complementary: '#d0ff4d',
            analogous: '#4d77ff',
            triadic: '#ff7c4d',
        },
        secondary: {
            main: '#DB491B',
        },
    },
    typography: {
        fontFamily: ['Roboto', 'Fira Sans'].join(','),
    },
})

// Loading fallback component
const LoadingFallback = () => (
    <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
    >
        <CircularProgress />
    </Box>
)

function App() {
    // No authentication needed! This is a public app
    return (
        <QueryClientProvider client={queryClient}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Suspense fallback={<LoadingFallback />}>
                    <Router>
                        <LocationProvider>
                            <PublicMapApp />
                        </LocationProvider>
                    </Router>
                </Suspense>
            </ThemeProvider>
        </QueryClientProvider>
    )
}

export default App